import List from "@/components/list";
import router from "@/router";
import { tableBaseProps } from '@/utils/common.js';

const Table = (args) => {
  const { listeners, props } = args;

  function goDetail(row) {
    const { reportName, uuid: reportId } = row
    router.push({
      path: 'declareClassPlan/detail',
      query: { reportId, reportName }
    })
  }

  function goManage(row) {
    const { reportName, uuid: reportId, reportStatusName } = row
    router.push({
      path: 'declareClassPlan/manage',
      query: { reportId, reportName, reportStatusName }
    })
  }

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      ["make_class_plan", "办班计划管理", () => goManage(item), "classReportPlan:page"],
    ];
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>)
  }

  const ClassName = ({ props: { vo } }) => {
    const row = vo.row;
    return (
      <span class="base-hover-char" onClick={() => goDetail(row)}>
        {row.reportName}
      </span>
    );
  };


  const AccountTableConfig = [
    {
      ...tableBaseProps("申报名称", "reportName", "m200"),
      showOverflowTooltip: false,
      render: (vo) => <ClassName vo={vo} />,
    },
    tableBaseProps("申报开始时间", "reportStartTime", "100"),
    tableBaseProps("申报结束时间", "reportEndTime", "100"),
    tableBaseProps("申报状态", "reportStatusName", "90"),
    tableBaseProps("发布时间", "publishDate", "170"),
    {
      label: "操作",
      fixed: "right",
      width: "90",
      render: (vo) => <Deal vo={vo} />,
    },
  ]
  return <List {...args} talbeCols={AccountTableConfig} />;
}
export default Table;
